import React from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import 'css.gg/icons/css/sand-clock.css';
import 'css.gg/icons/css/album.css';
import 'css.gg/icons/css/calendar-today.css';
import 'css.gg/icons/css/comment.css';

import VideoPlayer from 'components/VideoPlayer';
import defaultPic from 'assets/icon_cinema.png';

import './HighlightSection.scss';

function HighlightSection({
  title,
  location,
  video,
  profilePic,
  cinemaBio,
  onMoreInfosClick,
  tags = [],
  onPreviousClick,
  onLocationClick,
}) {
  const {t} = useTranslation();

  const formatDuration = min => {
    const hours = Math.floor(min / 60);
    const minutes = min % 60;
    return `${hours && hours > 0 && hours + 'h'}${minutes && minutes > 0 && minutes + 'min'}`;
  };

  return (
    <div className="HighlightSection-container">
      <div className="HS-return-arrow">
        <div className="gg-arrow-left" onClick={onPreviousClick} />
      </div>
      <div className="HighlightSection-inner">
        <h1 className="HS-title">{title}</h1>
        <h3
          className="HS-location"
          onClick={onLocationClick}
          style={{
            cursor: onLocationClick ? 'pointer' : 'default',
          }}
        >
          <div className="HS-pin" />
          {location}
        </h3>
        {video && (
          <div className="HS-player-container">
            <div className="HS-player">
              <VideoPlayer video={video} />
            </div>
          </div>
        )}
        {cinemaBio && (
          <div className="HS-bio-cinema-container">
            {profilePic && (
              <div className="HS-bio-pic">
                <img src={profilePic} alt="profilePicture" />
              </div>
            )}
            {!profilePic && (
              <div className="HS-bio-pic">
                <img src={defaultPic} style={{width: '70%', height: '70%'}} alt="profilePicture" />
              </div>
            )}
            {(cinemaBio || onMoreInfosClick) && (
              <div className="HS-bio-text-container">
                {cinemaBio && <p className="HS-bio-text">« {cinemaBio} »</p>}
                {onMoreInfosClick && (
                  <p className="HS-bio-details" onClick={() => onMoreInfosClick()}>
                    {t('Details-de-la-salle')}
                  </p>
                )}
              </div>
            )}
          </div>
        )}
        {tags.length > 0 && (
          <div className="HS-bio-film-container">
            {tags[0] !== 'undefinedmin.' && (
              <h3 className="HS-bio-tag">
                <i className="gg-sand-clock" /> {formatDuration(tags[0])}
              </h3>
            )}
            {tags[1] && (
              <h3 className="HS-bio-tag">
                <i className="gg-album" /> {tags[1]}
              </h3>
            )}
            {tags[2] && (
              <h3 className="HS-bio-tag">
                <i className="gg-calendar-today" /> {moment(tags[2]).format('DD-MM-YYYY')}
              </h3>
            )}
            {/* {tags[3] && (
              <h3 className="HS-bio-tag">
                <i className="gg-comment" /> {tags[3]}
              </h3>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
}

export default HighlightSection;
